import { DomesticCMSService } from 'CommonData/services/domesticCMS.service';
import { VisualisationGatewayService } from 'CommonData/services/visualisationGateway.service';
import { LayingPatternViewer } from 'CommonScripts/layingPatternViewer';
import { LoadingHelper } from 'CommonScripts/loadingHelper';
import { productSynopses } from './textureSelect';
import { ProductSynopses } from 'CommonData/poco';
import { InputHelper } from 'CommonScripts/inputHelper';
import { AppInteraction } from 'CommonScripts/appInteraction';
import { NavTypes } from './nav';

const lengthWidthValueOptionEl: Element = document.getElementsByClassName('js-domestic-basket-value-option-length-width')[0];
const squareMeterageValueOptionEl: Element = document.getElementsByClassName('js-domestic-basket-value-option-square-meterage')[0];
const baseBasketProductItemEl: Element = document.getElementsByClassName('js-domestic-basket-base-product-item')[0].cloneNode(true) as HTMLElement;
const baseBasketProductListEl: Element = document.getElementsByClassName('js-domestic-basket-base-product-list')[0];
const wastageInputEl: HTMLInputElement = document.getElementsByClassName('js-domestic-basket-wastage-input')[0] as HTMLInputElement;

export class DomesticBasket {
    private static readonly VAT_PERCENTAGE = 20;

    public static setEventListeners() {
        const formEl: HTMLFormElement  = document.getElementsByClassName('js-domestic-basket-checkout-form')[0] as HTMLFormElement;
        const valueOptionEls: HTMLCollectionOf<HTMLInputElement> = document.getElementsByClassName('js-domestic-basket-value-option') as HTMLCollectionOf<HTMLInputElement>;
        const lengthEl: HTMLInputElement = document.getElementsByName('dom-length')[0] as HTMLInputElement;
        const widthEl: HTMLInputElement = document.getElementsByName('dom-width')[0] as HTMLInputElement;
        const squareMeterageEl: HTMLInputElement = document.getElementsByName('dom-square-meterage')[0] as HTMLInputElement;

        wastageInputEl.addEventListener('input', (e: Event) => {
            const target: HTMLInputElement = e.target as HTMLInputElement;
            const wastagePercentageEl: Element = document.getElementsByClassName('js-domestic-basket-wastage-percentage')[0];
            wastagePercentageEl.innerHTML = target.value;
            this.render(!isNaN(this.getOverallM2IncWastage()));
        });

        lengthEl.addEventListener('keyup', InputHelper.debounce((e: InputEvent) => { 
            this.render();
        }, 500));

        widthEl.addEventListener('keyup', InputHelper.debounce((e: InputEvent) => { 
            this.render();
        }, 500));

        squareMeterageEl.addEventListener('keyup', InputHelper.debounce((e: InputEvent) => { 
            this.render();
        }, 500));

        formEl.addEventListener('submit', (e: SubmitEvent) => {
            this.submit(e);
        });

        if (valueOptionEls) {
            const valueOptionElsArr: Array<HTMLInputElement> = [].slice.call(valueOptionEls);
            valueOptionElsArr.forEach((el: HTMLInputElement) => {
                el.addEventListener('click', () => {
                    valueOptionElsArr.forEach((oEl: HTMLInputElement) => {
                        oEl.checked = false;
                    });

                    el.checked = true;

                    const option: string = el.getAttribute('value');
                    if (option === 'length-width') {
                        squareMeterageValueOptionEl.classList.add('hidden');
                        lengthWidthValueOptionEl.classList.remove('hidden');

                        [].slice.call(lengthWidthValueOptionEl.getElementsByTagName('input')).forEach((iEl: HTMLInputElement) => {
                            iEl.required = true;
                        });

                        [].slice.call(squareMeterageValueOptionEl.getElementsByTagName('input')).forEach((iEl: HTMLInputElement) => {
                            iEl.required = false;
                        });
                    } else if (option === 'square-meterage') {
                        lengthWidthValueOptionEl.classList.add('hidden');
                        squareMeterageValueOptionEl.classList.remove('hidden');

                        [].slice.call(squareMeterageValueOptionEl.getElementsByTagName('input')).forEach((iEl: HTMLInputElement) => {
                            iEl.required = true;
                        });

                        [].slice.call(lengthWidthValueOptionEl.getElementsByTagName('input')).forEach((iEl: HTMLInputElement) => {
                            iEl.required = false;
                        });
                    }

                    this.render(false);
                });
            });
        }

        document.addEventListener('menuopen', (e: CustomEvent) => {
            if (e.detail.navType === NavTypes.Basket) {
                this.render(false);
            }
        });
    }

    public static async render(submitAppInteraction: boolean = true) {
        const domesticLoadingEl: Element = document.getElementsByClassName('js-domestic-basket-loading')[0];

        try {
            domesticLoadingEl.classList.remove('hidden');

            const currentTexture: any = LayingPatternViewer.getCurrentTexture();
            const overallM2IncWastage: number = this.getOverallM2IncWastage();

            const wastagePercentageEl: Element = document.getElementsByClassName('js-domestic-basket-wastage-percentage')[0];
            const wastagePercentageAreaEl: Element = document.getElementsByClassName('js-domestic-basket-wastage-percentage-area')[0];
            const totalPriceEl: Element = document.getElementsByClassName('js-domestic-basket-total-price')[0];
            const totalInstallationPriceEl: Element = document.getElementsByClassName('js-domestic-basket-installation-price')[0];
            const productHeaderEl: Element = document.getElementsByClassName('js-domestic-basket-base-product-header')[0];

            if (!currentTexture || !overallM2IncWastage || isNaN(overallM2IncWastage)) {
                wastagePercentageAreaEl.innerHTML = '0.00';
                totalPriceEl.innerHTML = '0.00';
                totalInstallationPriceEl.innerHTML = '0.00';
                baseBasketProductListEl.innerHTML = '';

                productHeaderEl.classList.add('hidden');

                if (submitAppInteraction) {
                    AppInteraction.submit();
                }

                return;
            }

            const response: any = await VisualisationGatewayService.getSkuProductQuantities(
                currentTexture.PatternId, 
                overallM2IncWastage, 
                currentTexture.ProductTextureKey,
                `${currentTexture.JointWidthMM}_${currentTexture.JointTextureKey}_${currentTexture.MaskId}_${currentTexture.PatternId}`
            );

            baseBasketProductListEl.innerHTML = '';
            if (!response || !response.data) {
                console.error('Unable to find corresponding SKUs: DomesticBasket.render');
                return;
            }

            let totalPrice: number = 0;
            let totalInstallationPrice: number = 0;
            const skus: Array<any> = response.data;
            skus.forEach((sku: any) => {
                let matchingSku: any = null;
                productSynopses.forEach((ps: ProductSynopses) => {
                    if (!matchingSku) {
                        matchingSku = ps.skus.find((s: any) => s.productCode === sku.skuId);

                        if (matchingSku && ps.installPricePerM2Gross && !totalInstallationPrice) {
                            totalInstallationPrice = ps.installPricePerM2Gross * this.getOverallM2IncWastage();
                        }
                    }
                });

                if (!matchingSku) {
                    console.error('Unable to find matching SKU within listed product synopses: DomesticBasket.render');
                    return;
                }

                const prodEl: Element = baseBasketProductItemEl.cloneNode(true) as HTMLElement;
                const prodImgEl: HTMLImageElement = prodEl.getElementsByTagName('img')[0];
                const prodNameEl: Element = prodEl.getElementsByClassName('js-domestic-basket-base-product-item-name')[0];
                const prodPackEl: Element = prodEl.getElementsByClassName('js-domestic-basket-base-product-item-packs')[0];
                const prodPriceEl: Element = prodEl.getElementsByClassName('js-domestic-basket-base-product-item-price')[0];
                const basePrice: number = matchingSku.productPricePerPackNett * sku.packQuantity;
                const priceIncVAT: number = Math.round((basePrice + (basePrice / 100 * this.VAT_PERCENTAGE) + Number.EPSILON) * 100) / 100;

                prodImgEl.src = '';
                prodNameEl.innerHTML = matchingSku.name;
                prodPackEl.innerHTML = sku.packQuantity;
                prodPriceEl.innerHTML = `${priceIncVAT.toFixed(2)}`;

                totalPrice += priceIncVAT;

                baseBasketProductListEl.appendChild(prodEl);
            });

            if (!skus || !skus.length) {
                productHeaderEl.classList.add('hidden');
            } else {
                productHeaderEl.classList.remove('hidden');
            }

            wastagePercentageEl.innerHTML = wastageInputEl.value;
            wastagePercentageAreaEl.innerHTML = `${this.getOverallWastage()}`;
            totalPriceEl.innerHTML = `${totalPrice}`;
            totalInstallationPriceEl.innerHTML = `${Math.round(totalInstallationPrice)}`;
        } finally {
            domesticLoadingEl.classList.add('hidden');
        }
    }

    private static getOverallM2IncWastage() {
        return this.getOverallM2() + this.getOverallWastage();
    }

    private static getOverallM2() {
        const isUsingLengthWidth: boolean = !lengthWidthValueOptionEl.classList.contains('hidden');
        const lengthEl: HTMLInputElement = document.getElementsByName('dom-length')[0] as HTMLInputElement;
        const widthEl: HTMLInputElement = document.getElementsByName('dom-width')[0] as HTMLInputElement;
        const squareMeterageEl: HTMLInputElement = document.getElementsByName('dom-square-meterage')[0] as HTMLInputElement;
        const lengthVal: number = parseInt(lengthEl.value);
        const widthVal: number = parseInt(widthEl.value);
        const squareMeterageVal: number = parseInt(squareMeterageEl.value);

        return isUsingLengthWidth ? Math.round(((lengthVal * widthVal) + Number.EPSILON) * 100) / 100 : squareMeterageVal;
    }

    private static getOverallWastage() {
        const wastageValue: number = parseInt(wastageInputEl.value);
        return Math.round(((this.getOverallM2() / 100 * wastageValue) + Number.EPSILON) * 100) / 100;
    }

    private static async submit(e: SubmitEvent) {
        e.preventDefault();
        
        let submitType: string;
        if (e.submitter) {
            submitType = e.submitter.getAttribute('data-cta');
        }

        if (!submitType) {
            console.error('Unable to find domestic basket submit type: DomesticBasket.submit');
            return;
        }

        try {
            LoadingHelper.start();

            const currentTexture: any = LayingPatternViewer.getCurrentTexture();
            const response: any = await DomesticCMSService.postDomesticCTA({
                CTAAction: submitType,
                DesignAreas: [{
                    PatternId: currentTexture.PatternId,
                    OverallM2IncWastage: this.getOverallM2IncWastage(),
                    MaterialTextureKey: currentTexture.ProductTextureKey,
                    JointPatternTextureKey: `${currentTexture.JointWidthMM}_${currentTexture.JointTextureKey}_${currentTexture.MaskId}_${currentTexture.PatternId}`
                }]
            });

            setTimeout(() => {
                window.open(`${process.env.DOMESTIC_CMS_URL}/process-cta?${response.data}`);
            }, 0);
        } finally {
            LoadingHelper.stop();
        }
    }
}

DomesticBasket.setEventListeners();